import { ENDPOINTS, MIDDLEWARE } from "./api-endpoints";

export default async function getCount(body, trackingId) {
  try {
    const customHeaders = {
      'Content-Type': 'application/json',
      'authorization': trackingId,
    };

    const response = await fetch(MIDDLEWARE + ENDPOINTS.getCount, {
      method: 'POST',
      headers: customHeaders,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}
